<template>
  <edn-field
    v-if="!(irisMimic || getIrisRdonlyMode)"
    ref="edn_mail"
    @update:error="isReady($event)"
    @keyup="replaceWhiteSpace($event)"
    v-model="Value"
    v-bind="$attrs"
    v-on="$listeners"
    :pattern="pattern"
    :invalidMsg="invalidMsg"
  >
  </edn-field>
  <edn-mimic :rules="rules" v-bind="$attrs" :pattern="pattern" v-model="Value" type="mail" v-else />
</template>

<script>
import { ednRequired } from './mixins/ednRequired'
import ednMimic from './ednMimic'
import { ednMimicMix } from './mixins/ednMimicMix'
import { ednRegex } from './mixins/ednRegex'
import { ednValue } from './mixins/ednValue'

export default {
  components: {
    ednMimic,
  },
  props: {
    irisMimic: {
      type: Boolean,
      default: () => false,
    },
    pattern: {
      type: RegExp,
      default: () =>
        /^$|^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/i,
    },
    value: null
  },
  data() {
    return {
      linkContent: '',
      readyToConvert: null,
      linkMode: false,
    }
  },
  mixins: [ednRequired, ednRegex, ednMimicMix, ednValue],
  inheritAttrs: false,
  computed: {},
  methods: {
    // Remove space
     replaceWhiteSpace(e) {
      if (this.content) {        
        this.content = this.content.replaceAll(' ', '');
      }    
    },
  }
}
</script>

<style lang="scss">
div {
  &.v-input {
    &.v-text-field {
      &.linkIris {
        div {
          &.v-input__slot {
            :after {
              border: none;
            }
          }
        }
        input {
          text-decoration: underline;
          color: #1ca6fd;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
